import { render, staticRenderFns } from "./dSwitch.vue?vue&type=template&id=5740dd12&"
import script from "./dSwitch.vue?vue&type=script&lang=js&"
export * from "./dSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports